const initialState = {
    text: '',
    isLoading: false,
    result: [],
};
const searchBranch = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_SEARCH_BRANCH_AUTOCOMPLETE':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default searchBranch;
